import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isPasswordNotSetSelector } from '../../redux/user/user.selectors';
import { ProfileContainer as ProfileContainerComponent } from './profile-container';
const mapStateToProps = createStructuredSelector({
  passwordNotSet: isPasswordNotSetSelector
});
export const ProfileContainer = connect(mapStateToProps)(ProfileContainerComponent);